import { Button, Spinner } from 'design-system';
import { ChevronDown } from 'lucide-react';

import SymbolsPreview from '@/features/_shared/SymbolsPreview';

import { useSymbolsPreview } from './useSymbolsPreview';

import type { UIMessage } from '@tanstack/ai-client';

const SymbolsPreviewSection = ({ msg, isVisible }: { msg: UIMessage; isVisible: boolean }) => {
  const { gxCodes, trimmedGxCodes, results, isExpanded, toggleExpanded, hasMore } =
    useSymbolsPreview(msg);

  if (!isVisible || !gxCodes.length) return null;

  if (results.pending) {
    return (
      <div className='flex w-full items-center justify-center'>
        <Spinner className='size-6' />
      </div>
    );
  }

  return (
    <>
      <SymbolsPreview
        forChat
        enableQuery={false}
        items={results.data}
      />
      {hasMore && (
        <div
          className={
            trimmedGxCodes.length % 2 === 0 ? 'bg-gx-tile-dark px-4' : 'bg-gx-tile-light px-4'
          }
        >
          <Button
            className='text-gx-highlight'
            variant='ghost'
            onClick={toggleExpanded}
          >
            {isExpanded ? 'See less' : 'See more'}
            <ChevronDown
              className={`size-3.5 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
            />
          </Button>
        </div>
      )}
    </>
  );
};

export default SymbolsPreviewSection;
